import React from 'react';
import classes from './Button.module.css';
const Button=props=>{
    return(
        
        <div className={classes['card-button']}>{props.content}</div>
        
    )
}
export default Button;